import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import NotFoundPage from './components/NotFoundPage';
import PublicInfoPage from './components/PublicInfoPage';
import SeoLandingPage, { LandingPagesIndex, LP_INDEX_ROUTES, SEO_LANDING_ROUTES } from './components/SeoLandingPage';
import reportWebVitals from './reportWebVitals';

// Rotas válidas do SPA — qualquer outra exibe a página 404
// Atualize esta lista se criar novas "páginas" no frontend
const PUBLIC_INFO_ROUTES = new Set(['/sobre']);
const SPA_ROUTES = new Set(['/', '/backoffice', '/conta-api', '/configurar-slack-webhook', ...PUBLIC_INFO_ROUTES, ...SEO_LANDING_ROUTES, ...LP_INDEX_ROUTES]);

// Verifica se o caminho atual é uma rota conhecida do SPA
const currentPath = window.location.pathname;
const isKnownRoute = SPA_ROUTES.has(currentPath);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {PUBLIC_INFO_ROUTES.has(currentPath) ? (
      <PublicInfoPage />
    ) : LP_INDEX_ROUTES.has(currentPath) ? (
      <LandingPagesIndex />
    ) : SEO_LANDING_ROUTES.has(currentPath) ? (
      <SeoLandingPage />
    ) : isKnownRoute ? (
      <App />
    ) : (
      <NotFoundPage />
    )}
  </React.StrictMode>
);

// Se você quiser medir performance da aplicação, passe uma função aqui
// (por exemplo: reportWebVitals(console.log))
// Saiba mais em: https://bit.ly/CRA-vitals
reportWebVitals();
